var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-item',{class:_vm.hiddenErrorText?'hiddenError':'',attrs:{"label":_vm.getLabel,"prop":_vm.prop,"rules":_vm.getRules}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }